import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { SaleDeadlines } from 'src/app/models/sales/sales.model';
import { SaleSessionModel } from '../../models/sales/sale-settings.model';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { DatasourceModel, DeadlinesDataSource } from './deadlines-datasource';
import { DateFunctionsService } from 'src/app/services/date-functions.service';

@Component({
  selector: 'app-dead-lines-popup',
  templateUrl: './dead-lines-popup.component.html',
  styleUrls: ['./dead-lines-popup.component.scss'],
})
export class DeadLinesPopupComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  @Input() public sale: SaleDeadlines;

  public dataSource: DeadlinesDataSource;
  public columns = [
    'startDate',
    'hips',
    'xRayCommenceDate',
    'xRayCompletedDate',
    'xrayScopeTaken',
    'xrayScopeVisible',
  ];
  public displayedColumns$ = new BehaviorSubject(this.columns);
  datasource: DatasourceModel[] = [];
  constructor(public readonly modal: NgbActiveModal, private datefunctionsService: DateFunctionsService) {
    super();
  }
  closePopup(): void {
    this.modal.close(JSON.stringify(this.sale));
  }
  ngOnInit(): void {
    let data: DatasourceModel[] = [];
    if (this.sale.isBreezeUpSale) {
      this.columns.push('breezeDate');
      // Create data for breezeup
      data = this.createBreezeUpModal();
    } else {
      // create data for non-breeze up.
      data = this.createSaleSessionModel();
    }

    this.datasource = data;
    this.dataSource = new DeadlinesDataSource(data, null);
  }

  createBreezeUpModal(): DatasourceModel[] {
    let breezeUpDates: DatasourceModel[] = [];

    this.sale.saleSessions.forEach((saleSession) => {
      const mergedStartDate = this.mergeDateAndTime(saleSession.endDate, saleSession.startDate);
      const breezeUps = this.sale.saleBreezeUps
        .filter(
          (sb) =>
            sb.bookNumber === saleSession.bookNumber &&
            sb.sessionNumber === saleSession.sessionNumber
        )
        .map((sb) => {
          const ds = DatasourceModel.fromBreezeUp(
            sb,
            saleSession.minLotNumber,
            saleSession.maxLotNumber
          );
          return ds;
        });

      const model = new DatasourceModel(saleSession, breezeUps);
      model.breezeMaxLotNumber = saleSession.maxLotNumber;
      model.breezeMinLotNumber = saleSession.minLotNumber;
      model.startDate = mergedStartDate;
      breezeUpDates.push(model);
    });

    return breezeUpDates;
  }


  createSaleSessionModel(): DatasourceModel[] {
    return this.sale.saleSessions.map((saleSession) => {
      const mergedStartDate = this.mergeDateAndTime(saleSession.endDate, saleSession.startDate);
      saleSession.startDate = mergedStartDate;
      const model = new DatasourceModel(saleSession, []);
      model.breezeups = [new DatasourceModel({
        bookNumber: saleSession.bookNumber,
        breezeDate: saleSession.breezeDate,
        maxLotNumber: saleSession.maxLotNumber,
        minLotNumber: saleSession.minLotNumber,
        sessionNumber: saleSession.sessionNumber,
        startDate: saleSession.startDate,
        xrayScopeTaken: saleSession.xrayScopeTaken,
        xrayScopeVisible: saleSession.xrayScopeVisible
      } as SaleSessionModel, null)];
      return model;
    });
  }

  private mergeDateAndTime(datePart: Date, timePart: Date): Date {
    const date = new Date(datePart);
    const time = new Date(timePart);

    date.setHours(time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
    return date;
  }

  public showTimePart(date: Date) {
    return this.datefunctionsService.getTimePart(date);
  }
}
